module.exports = __webpack_public_path__ + "static/media/52.6fb84f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/52.png
// module id = 477
// module chunks = 0